import { useEffect } from "react";
import { supabase } from "../lib/supabaseClient";
import NotFound from "./NotFound.jsx";

// Renders identically to the real 404 (see NotFound.jsx) so a scanner can't
// tell it's been caught — the only difference is this fire-and-forget log
// call. Errors are swallowed: a failed log shouldn't affect what the
// visitor sees, and there's nothing useful to do with the error client-side.
export default function Honeypot({ path }) {
  useEffect(() => {
    supabase
      .rpc("log_honeypot_hit", {
        p_path: path,
        p_user_agent: navigator.userAgent,
        p_referrer: document.referrer || null,
      })
      .then(() => {})
      .catch(() => {});
  }, [path]);

  return <NotFound />;
}
